import { render } from "./Loading2.vue?vue&type=template&id=433019ef&scoped=true"
const script = {}

import "./Loading2.vue?vue&type=style&index=0&id=433019ef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433019ef"]])

export default __exports__